<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="SuggestionContent">
    <div class="hidden md:block relative">
      <div class="grid gap-10 sticky top-20">
        <CitySelector @select="$emit('selectCity', $event)" />
        <TableOfContents
          :content="professionTask.contentHtml"
          @item-clicked="$trackers.trackClick('TableOfContentsItem')"
        />
        <PriceRanges
          v-if="showPriceRanges"
          :profession-task="professionTask"
          :price-ranges="priceRanges"
        />
      </div>
    </div>
    <div>
      <TableOfContents
        class="md:hidden mb-4"
        :is-blog="true"
        :content="professionTask.contentHtml"
      />
      <div class="relative flex flex-col gap-2">
        <JoszakiHtmlTextBlock :text="professionTask.contentHtml" />
      </div>
    </div>
  </div>
</template>

<script>
import TableOfContents from "~/components/_refactored/app/boxes/TableOfContents.vue";
import PriceRanges from "~/components/_refactored/app/boxes/PriceRanges.vue";
import CitySelector from "~/components/_refactored/pricesPage/CitySelector.vue";
import JoszakiHtmlTextBlock from "~/components/_refactored/common/JoszakiHtmlTextBlock.vue";

export default {
  components: {
    TableOfContents,
    PriceRanges,
    CitySelector,
    JoszakiHtmlTextBlock,
  },
  props: {
    professionTask: {
      type: Object,
      required: true,
    },
    priceRanges: {
      type: Array,
      required: true,
    },
  },
  computed: {
    showPriceRanges() {
      return !!this.priceRanges.length && this.priceRanges[0].from > 0;
    },
  },
  methods: {
    requestTender(text) {
      this.$emit("requestTender", text);
    },
  },
};
</script>

<style lang="scss">
@use "styles/_all-members" as global;

.SuggestionContent {
  position: relative;
  display: grid;
  gap: 2rem;
  grid-template-columns: 100%;

  @include global.desktop {
    grid-template-columns: 360px 1fr;
  }
}

.hide-transition {
  &::before {
    content: "";
    height: 100%;
    width: 100%;
    background: linear-gradient(
      180deg,
      rgba(246, 246, 246, 0.01) 70%,
      rgba(246, 246, 246, 1) 100%
    );
    z-index: 100;
    position: absolute;
  }
}
</style>
